module.exports = __webpack_public_path__ + "static/login-image.b22b8e0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/login-image.jpg
// module id = 517
// module chunks = 230539012308250